import React from 'react'
import DocumentTitle from 'react-document-title'

export default () =>
  <DocumentTitle title={'Not Found'}>
    <div>
      <p>404</p>
    </div>
  </DocumentTitle>


// WEBPACK FOOTER //
// ./~/picidae-theme-grass/template/NotFound.js